import { castArray, flattenDeep } from 'lodash/fp';

export const mergeActions = (...params) => flattenDeep(params.map(castArray));
